import { render, staticRenderFns } from "./contract_inv_trans_detail.vue?vue&type=template&id=4c82311e&scoped=true"
import script from "./contract_inv_trans_detail.vue?vue&type=script&lang=js"
export * from "./contract_inv_trans_detail.vue?vue&type=script&lang=js"
import style0 from "./contract_inv_trans_detail.vue?vue&type=style&index=0&id=4c82311e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c82311e",
  null
  
)

export default component.exports